import { useState, useEffect, useRef } from 'react';
import './style.css';
import { Button } from 'react-bootstrap';
import { Modal, Box, Tooltip } from '@mui/material';
import Logo from '../../../img/doc-atento.png';
import QRCode from 'qrcode.react';
import api from '../../../services/api';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

interface DocumentoEmpresaProps {
    tipoConsulta?: any,
    empresa?: any,
    trabalhadorSelecionado: any,
    funcaoSelecionada: any,
    nomeGhe?: string,
    nomeFdt?: string,
    riscosIncluidos: any,
    examesCadastrados: any,
    nomeMedico?: any,
    crm?: any,
    uf?: any,
    trabalhoAltura?: any,
    trabalhoConfinado?: any,
    descontoTotal?: any,
    valorInicialTotal?: any,
    onClose: any,
    examesExcluidos?: any,
    isAsoPronto?: boolean,
    dadosCnae?: any,
}

export const DocumentoEmpresa: React.FC<DocumentoEmpresaProps> = ({ tipoConsulta,
    empresa,
    trabalhadorSelecionado,
    funcaoSelecionada,
    nomeGhe,
    nomeFdt,
    riscosIncluidos,
    examesCadastrados,
    examesExcluidos,
    nomeMedico,
    crm,
    uf,
    trabalhoAltura,
    trabalhoConfinado,
    descontoTotal,
    valorInicialTotal,
    onClose,
    isAsoPronto,
    dadosCnae
}) => {

    const [isDocumentAccessible, setIsDocumentAccessible] = useState(false);
    const contentRef = useRef(null);
    const navigate = useNavigate();
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [reaproveitamento, setReaproveitamento] = useState<any>();
    const [isSubmitting, setIsSubmitting] = useState(false);



    const style = {
        position: 'absolute',
        top: '80%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 1123,
        height: 1123,
    };

    const formatarData = (data: string) => {
        if (!data) return '';

        const isFormatted = data.includes('/');

        if (isFormatted) {
            return data;
        } else {
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        }
    };

    function formatDate(dateString: string): string {
        // Cria um objeto Date a partir da string ISO
        const date = new Date(dateString);

        // Extrai o dia, mês e ano no UTC
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() é zero-based
        const year = date.getUTCFullYear();

        // Formata a data no formato desejado
        return `${day}/${month}/${year}`;
    }

    const generatePDF = async () => {
        const content: any = contentRef.current;

        if (!content) {
            console.error('Content ref is null. Make sure the component has rendered.');
            return;
        }

        const doc: any = new jsPDF();
        const pages = content.querySelectorAll('.page');

        if (pages) {
            pages.forEach((element: any) => {
                element.style.backgroundImage = 'none';
            });
        }

        if (pages.length === 0) {
            console.error('No pages found. Make sure the content has a class "page".');
            return;
        }

        for (let i = 0; i < pages.length; i++) {
            const page = pages[i];
            const isLandscape = page.classList.contains('landscape');
            const orientation = isLandscape ? 'landscape' : 'portrait';

            if (i > 0) {
                doc.addPage([297, 210], orientation);
            }

            const canvas = await html2canvas(page, { scale: 1 });
            const imgData = canvas.toDataURL('image/jpeg');
            doc.addImage(imgData, 'JPEG', 0, 0);
        }

        const pdfBytes = doc.output('arraybuffer');

        if (!pdfBytes) {
            console.error('Failed to generate PDF bytes.');
        } else {
            console.log('PDF bytes generated successfully.');
        }

        return pdfBytes;
    };

    const handleSaveReaproveitamento = async () => {
        setIsSubmitting(true);

        const pdfBytes = await generatePDF();
        // if (!pdfBytes) {
        //     console.error('PDF bytes are undefined.');
        //     return;
        // }

        const data = {
            id_empresa: empresa?.id,
            id_funcao: funcaoSelecionada.id_funcao ? funcaoSelecionada.id_funcao : funcaoSelecionada.id,
            frente_de_trabalho: nomeFdt,
            ghe: nomeGhe,
            tipoConsulta: tipoConsulta,
            trabalho_altura: trabalhoAltura,
            trabalhoConfinado: trabalhoConfinado,
            id_trabalhador: trabalhadorSelecionado.id,
            nomeMedico: nomeMedico,
            valor_pago: descontoTotal ? 0.00 : valorInicialTotal,
            uf: uf,
            crm: crm,
            examesCadastrados,
            examesExcluidos,
            riscosIncluidos,
            liberado: 0,
            isAsoPronto
        }

        try {
            const response = await api.post('/upload-reaproveitamento-pdf',
                data
            );

            const reaproveitamento = response.data;
            setReaproveitamento(reaproveitamento);

            if (reaproveitamento && reaproveitamento.id && !reaproveitamento.id_empresa) {
                navigate(`/aso/registro/validar-info-reaproveitamento/${reaproveitamento.id}`);
            } else {
                console.log('PDF enviado com sucesso.');
                navigate('/reaproveitamento-aso');
            }
        } catch (error) {
            console.error('Erro ao enviar o PDF:', error);
        } finally {
            setIsSubmitting(false);
        }

        // setOpenPdfModal(true);
    };

    const calculateAge = (birthdate: string) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    useEffect(() => {
        //#TODO: corrigir URL em homologação
        setQrCodeUrl(
            ``
        )
    }, [empresa, trabalhadorSelecionado, reaproveitamento])

    const determinarAptidao = (trabalhoAltura: number, trabalhoConfinado: number) => {
        const status = [trabalhoAltura, trabalhoConfinado];

        const counts = {
            apto: status.filter(value => value === 1).length,
            inapto: status.filter(value => value === 2).length,
            na: status.filter(value => value === 3).length,
        };

        if (counts.apto > counts.inapto) return "APTO";
        if (counts.inapto > counts.apto) return "INAPTO";
        return "APTO"; // Considera APTO em caso de empate ou N/A
    };


    return (
        <>
            <Modal
                id="modal-pdf"
                open={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflow: 'auto' }}
                className={`${isDocumentAccessible ? 'teste' : 'planoModal'}`}
                slotProps={{
                    backdrop: {
                        style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' }
                    }
                }}
            >
                <Box sx={style}>
                    <div ref={contentRef} id="content-pdf">
                        <div className="page">
                            <div className="page-content capa">
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div style={{ width: '300px', border: '0.5px solid #C0C0C0' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                            <img src={Logo} alt="logo" style={{ width: '95%', height: '60px', marginTop: '10px', padding: '5px' }} />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                            <p style={{ fontSize: '11px', margin: 0 }}>ATENTO MEDICINA DO TRABALHO LTDA</p>
                                            <p style={{ fontSize: '10px', margin: 0 }}>CNPJ 11.509.053/0001-59</p>
                                            <p style={{ fontSize: '9px', margin: 0 }}>41 3642-6495</p>
                                            <p style={{ fontSize: '8px', margin: 0 }}>Rua Heitor Alves Guimarães, 495 - ARAUCÁRIA - PARANÁ</p>
                                        </div>
                                    </div>
                                    <div style={{ flex: 1, border: '0.5px solid #C0C0C0', borderLeft: 'none' }}>
                                        <p style={{ fontSize: '8px', margin: '1px' }}>
                                            ESTE DOCUMENTO ATENDE ÁS EXIGÊNCIAS DA NR-7, APROVADAS PELA PORTARIA Nº3.214, DE 8 DE JUNHO DE 1978,
                                            3164/82,12/83,24/94 E 08/96 DO MINISTÉRIO DO TRABALHO E EMPREGO PARA FINS DE EXAME.
                                        </p>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '70%' }}>
                                                <p style={{ fontSize: '11px', margin: 0 }}><b>ATESTADO DE SAÚDE OCUPACIONAL (Nº 17)</b></p>
                                                <p style={{ fontSize: '11px', margin: 0 }}><b>{tipoConsulta}</b></p>
                                                <p style={{ fontSize: '10px', margin: 0 }}>
                                                    ASO Gerado por reaproveitamento de exames
                                                </p>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30%' }}>
                                                <QRCode value={qrCodeUrl} size={110} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* DIV PRINCIPAL */}
                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                    {empresa && (
                                        <>
                                            <div style={{ display: 'flex', width: '23%', flexDirection: 'column' }}>
                                                <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>EMPRESA:</b></p>
                                                <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>ENDEREÇO:</b></p>
                                                <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>RAMO DE ATIVIDADE:</b></p>
                                                <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}><b>GRAU DE RISCO:</b></p>
                                            </div>
                                            <div style={{ display: 'flex', width: '77%', flexDirection: 'column' }}>
                                                <>
                                                    <p style={{ fontSize: '10px', margin: '2px' }}>{empresa.nome} <b style={{ marginLeft: '15px' }}>CNPJ: </b>{empresa.cnpj} </p>
                                                    <p style={{ fontSize: '10px', margin: '2px' }}>{empresa.endereco} - {empresa.numero}</p>
                                                    <p style={{ fontSize: '8px', margin: '2px' }}>{dadosCnae.cnae} {dadosCnae.nome}</p>
                                                    <p style={{ fontSize: '10px', margin: '2px' }}>{dadosCnae.g_risco}</p>
                                                </>
                                            </div>
                                        </>
                                    )}
                                </div>
                                {/* DIV PRINCIPAL */}
                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                    <div style={{ display: 'flex', width: '23%', flexDirection: 'column' }}>
                                        <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>TRABALHADOR(a):</b></p>
                                        <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>CPF:</b></p>
                                        <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>DATA DE NASCIMENTO:</b></p>
                                        <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>FUNÇÃO:</b></p>
                                        {nomeGhe && (
                                            <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>GHE (SETOR):</b></p>
                                        )}
                                        {nomeFdt && (
                                            <p style={{ fontSize: '10px', margin: '1px', marginLeft: '5px' }}><b>FRENTE DE TRABALHO:</b></p>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', width: '77%', flexDirection: 'column' }}>
                                        {trabalhadorSelecionado && (
                                            <>
                                                <p style={{ fontSize: '10px', margin: '1px' }}>{trabalhadorSelecionado.nome}</p>
                                                <p style={{ fontSize: '10px', margin: '1px' }}>{trabalhadorSelecionado.cpf} <b style={{ marginLeft: '15px' }}>RG: </b>{trabalhadorSelecionado.rg} <b style={{ marginLeft: '15px' }}>SEXO: </b>{trabalhadorSelecionado.sexo}</p>
                                                <p style={{ fontSize: '10px', margin: '1px' }}>{trabalhadorSelecionado.data_nascimento ? formatDate(trabalhadorSelecionado.data_nascimento) : ''} <b style={{ marginLeft: '15px' }}>IDADE: </b> {trabalhadorSelecionado.data_nascimento ? calculateAge(trabalhadorSelecionado.data_nascimento) : ''}</p>
                                                <p style={{ fontSize: '8px', margin: '1px' }}>{funcaoSelecionada ? funcaoSelecionada.nome || funcaoSelecionada.nomeFuncao : 'null'}</p>
                                                {nomeGhe && (
                                                    <p style={{ fontSize: '10px', margin: '1px' }}>{nomeGhe}</p>
                                                )}
                                                {nomeFdt && (
                                                    <p style={{ fontSize: '10px', margin: '1px' }}>{nomeFdt}</p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                                {/* DIV PRINCIPAL */}
                                <div style={{ width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th colSpan={3} style={{ textAlign: 'left', padding: '5px', fontSize: '10px' }}>
                                                    <b>RISCOS OCUPACIONAIS</b>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {riscosIncluidos.map((risco: any, index: number) => (
                                                <tr key={index}>
                                                    {(risco.AteBaseRiscosCat || risco.nomeCategoria) && (
                                                        <td style={{ width: '30%', border: '0.5px solid #C0C0C0', padding: '2px', fontSize: '7px' }}>
                                                            {risco.AteBaseRiscosCat?.categoria || risco?.nomeCategoria || risco.nome_categoria}
                                                        </td>
                                                    )}
                                                    <td style={{ width: '70%', border: '0.5px solid #C0C0C0', padding: '2px', fontSize: '7px' }}>
                                                        <ul style={{ margin: '0', paddingLeft: '20px' }}>
                                                            <li>{risco.nome || risco.nomeRisco || risco.risco}</li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {/* DIV PRINCIPAL */}
                                <div style={{ width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                        <thead>
                                            <tr>
                                                <th colSpan={5} style={{ textAlign: 'left', padding: '5px', fontSize: '10px' }}>
                                                    <b>EXAMES REALIZADOS</b>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.from({ length: Math.ceil(examesCadastrados.length / 20) }).map((_, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {Array.from({ length: 4 }).map((_, colIndex) => {
                                                        const startIndex = rowIndex * 20 + colIndex * 5;
                                                        const hasExams = examesCadastrados.slice(startIndex, startIndex + 5).length > 0;
                                                        return hasExams ? (
                                                            <td key={colIndex} style={{ border: '0.5px solid #C0C0C0', fontSize: '7px', padding: '5px', verticalAlign: 'top' }}>
                                                                {Array.from({ length: 5 }).map((_, subIndex) => {
                                                                    const examIndex = startIndex + subIndex;
                                                                    const exame: any = examesCadastrados[examIndex];
                                                                    return (
                                                                        <div key={subIndex} style={{ marginBottom: '5px' }}>
                                                                            {exame ? (
                                                                                <span>
                                                                                    {exame.ateBaseExames?.nome || exame.nome_exame}
                                                                                </span>
                                                                            ) : null}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </td>
                                                        ) : null;
                                                    })}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {/* DIV PRINCIPAL */}
                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none', justifyContent: nomeMedico ? 'space-between' : 'center', }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '50%' }}>
                                        <p style={{ fontSize: '10px', margin: '2px' }}>NOME DO MÉDICO EXAMINADOR COM CRM,</p>
                                        <p style={{ fontSize: '10px', margin: '2px' }}>CARIMBO E ASSINATURA</p>
                                        <hr style={{ width: '50%', borderColor: 'black', marginTop: '70px' }}></hr>
                                    </div>
                                    {nomeMedico && (

                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', width: '50%' }}>
                                            <p style={{ fontSize: '9px', margin: '2px' }}>NOME DO MÉDICO DO TRABALHO COORDENADOR DO PCMSO,</p>
                                            <p style={{ fontSize: '9px', margin: '2px' }}>COM CRM E ESTADO EMISSOR</p>
                                            <hr style={{ width: '50%', borderColor: 'black', marginTop: '68px', marginBottom: 0 }}></hr>
                                            <p style={{ fontSize: '7px', margin: 0 }}>{nomeMedico} CRM {crm}  / {uf}</p>
                                        </div>

                                    )}
                                </div>
                                {/* DIV PRINCIPAL */}
                                {tipoConsulta && (
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ width: '50%' }}>
                                            <h6 style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>APTIDÃO</h6>
                                            <h6 style={{ fontSize: '10px', marginLeft: '5px' }}>
                                                APTO PARA FUNÇÃO [ {determinarAptidao(trabalhoAltura, trabalhoConfinado) === 'APTO' ? 'x' : ''} ]
                                            </h6>
                                        </div>
                                        <div style={{ width: '50%' }}>
                                            <h6 style={{ fontSize: '10px' }}>
                                                INAPTO PARA A FUNÇÃO [ {determinarAptidao(trabalhoAltura, trabalhoConfinado) === 'INAPTO' ? 'x' : ''} ]
                                            </h6>
                                        </div>
                                    </div>
                                )}
                                {/* DIV PRINCIPAL */}
                                {trabalhoAltura && trabalhoConfinado && (
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                        <div style={{ width: '30%' }}>
                                            <h6 style={{ fontSize: '11px', margin: '2px', marginLeft: '5px' }}>TRABALHOS ESPECIAIS</h6>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>Trabalho em Altura:</p>
                                            <p style={{ fontSize: '10px', margin: '2px', marginLeft: '5px' }}>Trabalho em Espaço Confinado:</p>
                                        </div>
                                        <div style={{ width: '20%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura === 1 ? 'X' : ''} ] APTO</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado === 1 ? 'X' : ''} ] APTO</p>
                                        </div>
                                        <div style={{ width: '20%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura === 2 ? 'X' : ''} ] INAPTO</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado === 2 ? 'X' : ''} ] INAPTO</p>
                                        </div>
                                        <div style={{ width: '30%' }}>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoAltura === 3 ? 'X' : ''} ] N/A</p>
                                            <p style={{ fontSize: '10px', margin: '2px' }}>[ {trabalhoConfinado === 3 ? 'X' : ''} ] N/A</p>
                                        </div>
                                    </div>

                                )}
                                {/* DIV PRINCIPAL */}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', border: '0.5px solid #C0C0C0', borderTop: 'none' }}>
                                    <h6 style={{ fontSize: '12px', margin: '2px' }}>ASSINATURA DO EMPREGADO</h6>
                                    <h6 style={{ fontSize: '12px', margin: '2px' }}>RECEBI CÓPIA DO ASO NESTA DATA</h6>
                                    <hr style={{ width: '50%', borderColor: 'black', marginTop: '68px', marginBottom: 0 }}></hr>
                                    {trabalhadorSelecionado && (
                                        <h6 style={{ fontSize: '10px', margin: '2px' }}>{trabalhadorSelecionado.nome}</h6>
                                    )}
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '30px' }}>
                                        <p style={{ fontSize: '10px', margin: '2px' }}>DATA DE EMISSÃO DO ASO:</p>
                                        <p style={{ fontSize: '10px', margin: '2px' }}>{formatarData(new Date().toISOString().split('T')[0])}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Tooltip title="Finalizar Reaproveitamento">
                        <Button className='btn-main mt-4' style={{ width: '250px', position: 'fixed', top: '1px', right: '-100px' }} onClick={handleSaveReaproveitamento} disabled={isSubmitting}>
                            {isSubmitting ? (
                                'Enviando...'
                            ) : (
                                'Enviar para assinatura'
                            )}
                        </Button>
                    </Tooltip>
                </Box>
            </Modal>

        </>
    )
}